// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SiteAccountModel {
    static getAttributeTypeMap() {
        return SiteAccountModel.attributeTypeMap;
    }
}
SiteAccountModel.discriminator = undefined;
SiteAccountModel.additionalProperties = false;
SiteAccountModel.attributeTypeMap = [
    {
        "name": "account",
        "baseName": "account",
        "type": "AccountModel"
    },
    {
        "name": "site",
        "baseName": "site",
        "type": "SiteModel"
    },
];
//# sourceMappingURL=siteAccountModel.js.map